export default __webpack_public_path__ + "static/media/oto-web-icon.3abebac0.png";